import { call, put } from "redux-saga/effects";
import httpErrorHelpers from "../../services/httpUtilities/httpErrorHelpers";
import api from "../../services/httpUtilities/httpService";
import * as twilioAction from "../actions/twilio";

function* watcherGetTwilioGetFileStatus({ fileName }, effects) {
  try {
    const response = yield call(api.twilioGetFileStatus, fileName);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(twilioAction.getTwilioGetFileStatusSuccess(data));
    } else {
      const message = "Get Twilio Get File Status Unsuccessful";
      yield put(twilioAction.getTwilioGetFileStatusFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      twilioAction.getTwilioGetFileStatusFailure,
      effects
    );
  }
}

function* watcherGetTwilioRequestOTP({ fileName }, effects) {
  try {
    const response = yield call(api.twilioRequestOTP, fileName);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(twilioAction.getTwilioRequestOTPSuccess(data));
    } else {
      const message = "Get Twilio Request OTP";
      yield put(twilioAction.getTwilioRequestOTPFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      twilioAction.getTwilioRequestOTPFailure,
      effects
    );
  }
}

function* watcherGetTwilioGetFile({ fileName,otpCode }, effects) {
  try {
    const response = yield call(api.twilioGetFile, fileName,otpCode);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(twilioAction.getTwilioGetFileSuccess(data));
    } else {
      const message = "Get Twilio Get File";
      yield put(twilioAction.getTwilioGetFileFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      twilioAction.getTwilioGetFileFailure,
      effects
    );
  }
}

export {
  watcherGetTwilioGetFileStatus,
  watcherGetTwilioRequestOTP,
  watcherGetTwilioGetFile,
};
